import moment from 'moment';
import { getTimezoneOffset } from '@/common/timezone/timezone';

export const applyTimezoneOffset = (date: string, addTimezone: boolean): string => {
  if (!date) {
    return null;
  }
  const timezoneOffset: number = getTimezoneOffset();
  if (!timezoneOffset) {
    return date;
  }
  const dateWithOffset = addTimezone
    ? moment(date).add(timezoneOffset, 'hours')
    : moment(date).add(-timezoneOffset, 'hours');
  if (!dateWithOffset.isValid()) {
    return null;
  }
  return new Date(dateWithOffset.toString()).toISOString();
};
